import {createContext} from "react";
import {initialAuthState} from "./helpers.ts";

const stub = (): never => {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};

/**
 * @ignore
 */
export const initialContext = {
    ...initialAuthState,
    getAccessTokenSilently: stub,
    getIdTokenClaims: stub,
    handleRedirectCallback: stub,
};

const Auth0Context = createContext(initialContext);

export default Auth0Context;
